import React from 'react';
import { Resources } from '../Assets/Resources';

export default function AppLogo({ width = 120, height = 120}) {

    return (
        <img style={{width, height}} src={Resources.Logo} alt="app" />
    )
}